import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-200 min-h-screen relative pb-12" }
const _hoisted_2 = { class: "flex-grow pt-16" }
const _hoisted_3 = { class: "mx-auto pl-20 pr-20 pt-20 pb-10 text-center" }
const _hoisted_4 = { class: "mx-auto text-center pb-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavbarComponent),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'circle-exclamation'],
          class: "pb-5 text-6xl text-red-700"
        }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-lg md:text-2xl" }, "¡Atención!", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-lg md:text-2xl" }, "La página no fue encontrada", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/empresa",
          class: "px-4 py-2 text-center text-black border border-black rounded hover:bg-black hover:text-white transition uppercase"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'house'],
              class: "mr-2"
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" Volver al home "))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}